import type { ArtistSectionKey } from '../getArtistSections';
import { page } from '$app/state';

/**
 * Reads the section's persisted item count from the current history entry
 * (shallow-routing state). Reactive when read inside a rune, so a
 * back/forward navigation that restores the entry's state re-runs the caller.
 *
 * `page.state` is optional-chained only because unit-test mocks of
 * `$app/state` supply `data` without `state`; SvelteKit itself always
 * provides an object.
 */
export const getArtistSectionCount = (
	key: ArtistSectionKey
): number | undefined => page.state?.artistSectionCounts?.[key];
